// Preloads the JS chunk for a route when the user hovers or focuses a link.
// Each call triggers a dynamic import so the browser fetches and caches the
// module before the user actually navigates — cuts perceived navigation lag.

const PRELOADS = {
  '/shop': () => import('../pages/Shop'),
  '/dogs': () => import('../pages/Category'),
  '/cats': () => import('../pages/Category'),
  '/small-animals': () => import('../pages/Category'),
  '/health-and-wellness': () => import('../pages/Category'),
  '/product': () => import('../pages/ProductDetail'),
  '/cart': () => import('../pages/Cart'),
  '/about': () => import('../pages/About'),
};

const preloaded = new Set();

export function preloadRoute(path) {
  if (!path) return;
  for (const [prefix, load] of Object.entries(PRELOADS)) {
    if (path === prefix || path.startsWith(prefix + '/')) {
      if (!preloaded.has(prefix)) {
        preloaded.add(prefix);
        load().catch(() => {});
      }
      return;
    }
  }
}
